import React, { FunctionComponent } from "react";
import classNames from "classnames";

import "./FeatureGroupNumericTitle.scss";

export interface FeatureGroupNumericTitleProps {
    title: string;
    className?: string;
    titleNumber: number;
}

export const FeatureGroupNumericTitle: FunctionComponent<FeatureGroupNumericTitleProps> = ({
    title,
    className,
    titleNumber,
}) => {
    return (
        <div className={classNames("feature_group_title", className)}>
            <span className="feature_group_number_icon">{titleNumber}</span>
            <div className="feature_group_label">{title}</div>
        </div>
    );
};
